import { SodiumPlus } from 'sodium-plus';

export class SymmetricTreezorEncryption {
  private static instance: SymmetricTreezorEncryption;
  private sodium: SodiumPlus | undefined;

  private constructor() {}

  static getInstance(): SymmetricTreezorEncryption {
    if (!SymmetricTreezorEncryption.instance) {
      this.instance = new SymmetricTreezorEncryption();
    }

    return this.instance;
  }

  async init() {
    if (!this.sodium) {
      this.sodium = await SodiumPlus.auto();
    }
  }

  /**
   * @param {string} key The hex key to encrypt
   * @param {string} passphrase The passphrase used to to encrypt key
   *
   * @return {Promise<string>} The hex key encryted with passphrase, hex salt and hex nonce used
   */
  async encryptKey(key: string, passphrase: string): Promise<string> {
    try {
      if (!this.sodium) return Promise.reject('[SymmetricTreezorEncryption] Sodium not initialized');

      const saltBin = await this.sodium.randombytes_buf(16);
      const saltHex = await this.sodium.sodium_bin2hex(saltBin);

      const nonceBin = await this.sodium.randombytes_buf(24);
      const nonceHex = await this.sodium.sodium_bin2hex(nonceBin);

      const passwordKey = await this.sodium.crypto_pwhash(
        32,
        passphrase,
        saltBin,
        this.sodium.CRYPTO_PWHASH_OPSLIMIT_INTERACTIVE,
        this.sodium.CRYPTO_PWHASH_MEMLIMIT_INTERACTIVE,
      );

      const encryptedKeyBin = await this.sodium.crypto_secretbox(
        await this.sodium.sodium_hex2bin(key),
        nonceBin,
        passwordKey,
      );

      const encryptedKeyHex = await this.sodium.sodium_bin2hex(encryptedKeyBin);

      return `${saltHex}.${encryptedKeyHex}.${nonceHex}`;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async decryptKey(encryptedKey: string, passphrase: string): Promise<string> {
    try {
      if (!this.sodium) return Promise.reject('[SymmetricTreezorEncryption] Sodium not initialized');

      const [salt, key, nonce] = encryptedKey.split('.');

      if (!salt || !key || !nonce) throw new Error('Encrypted Key malformed. Expected Format : [salt].[key].[nonce]');

      this.sodium.CRYPTO_AUTH_BYTES;
      const passwordKey = await this.sodium.crypto_pwhash(
        32,
        passphrase,
        await this.sodium.sodium_hex2bin(salt),
        this.sodium.CRYPTO_PWHASH_OPSLIMIT_INTERACTIVE,
        this.sodium.CRYPTO_PWHASH_MEMLIMIT_INTERACTIVE,
      );
      const decryptedKeyBin = await this.sodium.crypto_secretbox_open(
        await this.sodium.sodium_hex2bin(key),
        await this.sodium.sodium_hex2bin(nonce),
        passwordKey,
      );

      const decryptedKeyHex = await this.sodium.sodium_bin2hex(decryptedKeyBin);

      return decryptedKeyHex;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
